var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col",class:_vm.position},[_c('a',{staticClass:"button-standard disabled:opacity-75 disabled:cursor-not-allowed",class:_vm.negative
        ? ("bg-white text-" + _vm.color + "-primary")
        : ("bg-" + _vm.color + " hover:bg-" + _vm.color + "-lighter text-white"),attrs:{"disabled":_vm.$attrs.disabled,"href":_vm.link}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }